<template>
  <transition name="fade">
    <v-card class="pa-4 mb-4">
      <v-form @submit.prevent="checkForm">
        <v-select
          v-model="index_hotel"
          :items="hoteles"
          item-value="id"
          item-text="Nombre"
          label="Agencia asignada al usuario"
          :error-messages="errors.hotel"
          required
        ></v-select>

        <v-text-field
          v-model="nombre"
          label="Nombre Completo"
          :error-messages="errors.nombre"
          required
        ></v-text-field>

        <v-text-field
          v-model="username"
          label="Username"
          :error-messages="errors.username"
          required
        ></v-text-field>

        <v-text-field
          v-model="password"
          label="Password"
          type="password"
          :error-messages="errors.password"
          :rules="rules.password"
          required
        ></v-text-field>

        <v-row justify="end">
          <v-btn class="mr-2" @click="$emit('toggle', false)">Cancelar</v-btn>
          <v-btn color="success" type="submit">Guardar</v-btn>
        </v-row>
      </v-form> </v-card
    >/*
  </transition>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>

<script>
export default {
  name: "AddUsuarios",
  components: {},
  props: ["hoteles"],
  data() {
    return {
      nombre: "",
      username: "",
      password: "",
      index_hotel: "",
      errors: [],
      rules: {
        password: [
          (value) =>
            value >= 6 || "La contraseña debe ser de al menos 6 caracteres",
        ],
      },
    };
  },
  methods: {
    checkForm: function (e) {
      e.preventDefault();
      let valid = true;

      this.errors = [];

      if (!this.nombre) {
        this.errors.nombre = "El nombre del usuario es obligatorio";
        valid = false;
      } else {
        this.errors.nombre = false;
      }

      if (!this.hotel) {
        this.errors.hotel = "La agencia es obligatoria";
        valid = false;
      } else {
        this.errors.hotel = false;
      }

      if (!this.username) {
        this.errors.username = "El usuario es obligatorio";
        valid = false;
      } else {
        this.errors.username = false;
      }

      if (!this.password || this.password.length <= 6) {
        this.errors.password = !this.password
          ? "La contraseña es obligatoria"
          : "La contraseña debe ser mayor o igual a 6 caracteres";
        valid = false;
      } else {
        this.errors.password = false;
      }

      /*
        if (!this.HoraFinal) {
            this.errors.hfinal = 'La hora final es requerida';
            valid = false;
        }else{
            this.errors.hfinal = false;
        }*/

      if (valid) {
        let data_hotel = this.hotel;
        this.$emit("successData", this.$data, data_hotel);
      }
    },
  },
  computed: {
    hotel() {
      return this.$pgsHelper.searchIndex(this.hoteles, "id", this.index_hotel);
    },
  },
  watch: {},
  beforeMount: function () {},
  mounted() {},
};
</script>
